/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPointsInfoRespVo
 */
export interface UserPointsInfoRespVo {
    /**
     * 积分记录ID
     * @type {number}
     * @memberof UserPointsInfoRespVo
     */
    id?: number;
    /**
     * 用户 ID
     * @type {number}
     * @memberof UserPointsInfoRespVo
     */
    userId?: number;
    /**
     * 积分数量
     * @type {number}
     * @memberof UserPointsInfoRespVo
     */
    amount?: number;
    /**
     * 冻结金额
     * @type {number}
     * @memberof UserPointsInfoRespVo
     */
    freezeAmount?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserPointsInfoRespVo
     */
    enable?: number;
}

/**
 * Check if a given object implements the UserPointsInfoRespVo interface.
 */
export function instanceOfUserPointsInfoRespVo(value: object): value is UserPointsInfoRespVo {
    return true;
}

export function UserPointsInfoRespVoFromJSON(json: any): UserPointsInfoRespVo {
    return UserPointsInfoRespVoFromJSONTyped(json, false);
}

export function UserPointsInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointsInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'freezeAmount': json['freezeAmount'] == null ? undefined : json['freezeAmount'],
        'enable': json['enable'] == null ? undefined : json['enable'],
    };
}

export function UserPointsInfoRespVoToJSON(json: any): UserPointsInfoRespVo {
    return UserPointsInfoRespVoToJSONTyped(json, false);
}

export function UserPointsInfoRespVoToJSONTyped(value?: UserPointsInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'amount': value['amount'],
        'freezeAmount': value['freezeAmount'],
        'enable': value['enable'],
    };
}

